import React from 'react';
import PropTypes from 'prop-types';

import { Text, Heading } from 'components/common/Elements/Elements';

import classes from './SideBarBody.module.scss';

const SideBarBody = ({ groups }) => {
  return (
    <>
      <div className={classes.wrapTitle}>
        <Heading className={classes.title} size={2}>
          Groups
        </Heading>
      </div>

      {groups.map(group => (
        <div className={classes.labelInfoWrap} key={group.id}>
          <Heading>{group.name}</Heading>
          <Text type={'p'}>id: {group.id}</Text>
        </div>
      ))}
    </>
  );
};

SideBarBody.propTypes = {
  groups: PropTypes.array
};

export default SideBarBody;
